globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.AssociateNewMediaFolder = (function(superClass) {

  utils.extend(AssociateNewMediaFolder, superClass);

  function AssociateNewMediaFolder() {
    return AssociateNewMediaFolder.__super__.constructor.apply(this, arguments);
  }

  $.extend(AssociateNewMediaFolder.prototype, {
    init: function() {
      var modal = this;

      $('.modal.show-media-file .new-folder-item').removeClass('loading');

      modal.$html.on('change', 'select#accounts_media_image_folder_files_attributes_0_folder_id', function(){
        modal.$html.find('button.submit').prop('disabled', $(this).val() == "");
      });

      return AssociateNewMediaFolder.__super__.init.apply(this, arguments);
    },
    updateView: function(data) {
      if(data.views.folder_files) {
        var $modalShowImage = $('.modal.show-media-file');
        if($modalShowImage.length) {
          $modalShowImage.find('.folder-items').replaceWith($(data.views.folder_files));
          appCustomerSpace.LimitlessPlugins.Tooltip.init($modalShowImage.find('.folder-items'));
        }
      }
    }
  });

  return AssociateNewMediaFolder;

})(appCustomerSpace.Modal);
